module.exports = __webpack_public_path__ + "static/media/SOLUS_LR_MARKER_11.25deg.f8db5253.png";